<!-- Change my password -->
<div class="mx-4 my-4 px-4 py-4 flex flex-col text-white bg-black/15 rounded-sm">
  <h1 class="text-lg font-bold text-app-teal-100">My Account</h1>
  <h2 class="text-md">Change password</h2>
  <h3 class="text-sm text-gray-400">
    Resets your Cognito password directly — no email code needed. Useful when the Hosted-UI logout / Forgot Password flow is unavailable.
  </h3>
  <div class="mt-3 flex flex-col gap-2 max-w-md">
    <input type="password" placeholder="New password (min 8 chars)" autocomplete="new-password"
      [(ngModel)]="newPassword"
      class="px-3 py-2 bg-black/30 text-white rounded-sm border border-white/10 focus:outline-none focus:border-app-teal-100" />
    <input type="password" placeholder="Confirm new password" autocomplete="new-password"
      [(ngModel)]="confirmNewPassword"
      class="px-3 py-2 bg-black/30 text-white rounded-sm border border-white/10 focus:outline-none focus:border-app-teal-100" />
    <div *ngIf="newPassword && confirmNewPassword && newPassword !== confirmNewPassword" class="text-sm text-red-400">
      Passwords don't match.
    </div>
    <button (click)="on_change_password()" [disabled]="!can_change_password()"
      class="mt-1 self-start px-4 py-2 bg-app-teal-100 text-black rounded-sm cursor-pointer hover:bg-app-teal-100/80 disabled:opacity-50 disabled:cursor-not-allowed">
      {{ changingPassword ? 'Updating…' : 'Update password' }}
    </button>
  </div>
</div>

<!-- Fingerprints data upload -->
<div class="mx-4 my-4 px-4 py-4 flex flex-col text-white bg-black/15 rounded-sm">
  <h1 class="text-lg font-bold text-app-teal-100">OptionPit - Fingerprints</h1>
  <h2 class="text-md">Daily Data Upload</h2>
  <h3 class="text-sm text-gray-400">Select the .csv file to upload to the db</h3>
  <div class="flex items-center gap-2 my-2">
    <!-- <label for="fileUpload" class="px-3 py-1 bg-app-teal-100 text-black rounded-sm cursor-pointer hover:bg-app-teal-200">
      Select File
    </label> -->
    <!-- <span id="fileName" class="text-sm text-gray-300">No file selected</span> -->
    <input class="w-full" type="file" id="fileUpload" name="uploadedFile" accept=".csv" (change)="onFingerprintsFileSelected($event)">
  </div>
  <div *ngIf="fingerprints_data?.length" class="mt-4 px-4 py-4 bg-app-teal-100/15 rounded-sm flex items-center">
    <span>Total Alerts to upload: </span>
    <span class="font-bold ml-2 text-app-teal-100">{{(fingerprints_data.length - 1)}}</span>
    <button (click)="onUploadFingerprintsClick()" class="ml-4 px-4 py-2 bg-app-teal-100 text-white rounded-sm cursor-pointer">
      Confirm Upload
    </button>
  </div>
</div>